import apiService from './api/api.service';
import { logger } from '@utils/logger';

class SupportService {
  async createTicket(ticketData) {
    try {
      const response = await apiService.post('/support/tickets', ticketData);
      return response;
    } catch (error) {
      logger.error('Error creating support ticket', error);
      throw error;
    }
  }

  async getUserTickets(filters = {}) {
    try {
      const response = await apiService.get('/support/tickets', { params: filters });
      return response;
    } catch (error) {
      logger.error('Error fetching user tickets', error);
      throw error;
    }
  }

  async getTicketById(ticketId) {
    try {
      const response = await apiService.get(`/support/tickets/${ticketId}`);
      return response;
    } catch (error) {
      logger.error('Error fetching ticket details', error);
      throw error;
    }
  }

  async addResponse(ticketId, message) {
    try {
      const response = await apiService.post(`/support/tickets/${ticketId}/responses`, { message });
      return response;
    } catch (error) {
      logger.error('Error adding ticket response', error);
      throw error;
    }
  }

  async getAllTickets(filters = {}) {
    try {
      const response = await apiService.get('/support/admin/tickets', { params: filters });
      return response;
    } catch (error) {
      logger.error('Error fetching all tickets', error);
      throw error;
    }
  }

  async updateStatus(ticketId, status) {
    try {
      const response = await apiService.put(`/support/admin/tickets/${ticketId}/status`, { status });
      return response;
    } catch (error) {
      logger.error('Error updating ticket status', error);
      throw error;
    }
  }

  async assignTicket(ticketId, adminId) {
    try {
      const response = await apiService.put(`/support/admin/tickets/${ticketId}/assign`, { adminId });
      return response;
    } catch (error) {
      logger.error('Error assigning ticket', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await apiService.get('/support/admin/stats');
      return response;
    } catch (error) {
      logger.error('Error fetching support stats', error);
      throw error;
    }
  }
}

export default new SupportService();
